/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Timeline_ObservedInputs */

const id_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const ms_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const da_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const de_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const en_us2_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const es_es2_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observadas en tu zona horaria`)
};

const es_mx2_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observado según tu zona horaria`)
};

const fil_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const fr_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const it_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const hu_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const nl_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const no_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const pl_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const pt_br2_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const pt_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const ro_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const fi_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const sv_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const vi_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const tr_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const cs_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const bg_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const ru_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время указано для вашего часового пояса`)
};

const uk_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const ar_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const hi_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके समय क्षेत्र में देखा गया`)
};

const th_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลาที่พบตามเขตเวลาของคุณ`)
};

const ja_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const zh_cn2_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

const zh_hant1_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`依你所在時區顯示的觀察時間`)
};

const ko_builds_timeline_observed = /** @type {(inputs: Builds_Timeline_ObservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed in your timezone`)
};

/**
* | output |
* | --- |
* | "Observed in your timezone" |
*
* @param {Builds_Timeline_ObservedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_timeline_observed = /** @type {((inputs?: Builds_Timeline_ObservedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Timeline_ObservedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_timeline_observed(inputs)
	if (locale === "ms") return ms_builds_timeline_observed(inputs)
	if (locale === "da") return da_builds_timeline_observed(inputs)
	if (locale === "de") return de_builds_timeline_observed(inputs)
	if (locale === "en-US") return en_us2_builds_timeline_observed(inputs)
	if (locale === "es-ES") return es_es2_builds_timeline_observed(inputs)
	if (locale === "es-MX") return es_mx2_builds_timeline_observed(inputs)
	if (locale === "fil") return fil_builds_timeline_observed(inputs)
	if (locale === "fr") return fr_builds_timeline_observed(inputs)
	if (locale === "it") return it_builds_timeline_observed(inputs)
	if (locale === "hu") return hu_builds_timeline_observed(inputs)
	if (locale === "nl") return nl_builds_timeline_observed(inputs)
	if (locale === "no") return no_builds_timeline_observed(inputs)
	if (locale === "pl") return pl_builds_timeline_observed(inputs)
	if (locale === "pt-BR") return pt_br2_builds_timeline_observed(inputs)
	if (locale === "pt") return pt_builds_timeline_observed(inputs)
	if (locale === "ro") return ro_builds_timeline_observed(inputs)
	if (locale === "fi") return fi_builds_timeline_observed(inputs)
	if (locale === "sv") return sv_builds_timeline_observed(inputs)
	if (locale === "vi") return vi_builds_timeline_observed(inputs)
	if (locale === "tr") return tr_builds_timeline_observed(inputs)
	if (locale === "cs") return cs_builds_timeline_observed(inputs)
	if (locale === "bg") return bg_builds_timeline_observed(inputs)
	if (locale === "ru") return ru_builds_timeline_observed(inputs)
	if (locale === "uk") return uk_builds_timeline_observed(inputs)
	if (locale === "ar") return ar_builds_timeline_observed(inputs)
	if (locale === "hi") return hi_builds_timeline_observed(inputs)
	if (locale === "th") return th_builds_timeline_observed(inputs)
	if (locale === "ja") return ja_builds_timeline_observed(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_timeline_observed(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_timeline_observed(inputs)
	return ko_builds_timeline_observed(inputs)
});
export { builds_timeline_observed as "builds.timeline.observed" }